import React, { useState } from "react";
import { API_URL } from "../../utils/constants";
import axios from "axios";
import { useAuth } from "../../utils/AuthContext";


const Feedback = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [rating, setRating] = useState(0);
    const [message, setMessage] = useState("");
    const labels = ["Poor", "Bad", "Okay", "Good", "Excellent"];
    const { user } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const response = await axios.post(
            `${API_URL}api/feedback`,
            {
                user_id: user?.userId,
                feedbacktext: message,
                feedbackrating: rating,

            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
        if (response) {
            setSubmitted(true);
        }
    };

    const handleClose = () => {
        setIsOpen(false);
        setSubmitted(false);
        setRating(0);
        setMessage("");
    };

    return (
        <>
            <div className="w-full h-full flex justify-center items-center">
                <button
                    onClick={() => setIsOpen(true)}
                    className="flex w-full h-full justify-center items-center gap-2 text-white font-semibold"
                >
                    <span className="text-base leading-none">Feedback</span>
                    <span className="text-xl leading-none flex items-center">★</span>
                </button>
            </div>
            {isOpen && (
                <div className="fixed bottom-0 left-0 w-screen h-screen bg-black/40 flex justify-center items-center z-[1000] ">
                    <div className="flex flex-col w-[80vw] sm:w-[40vw] min-h-[50vh] max-h-[90vh] bg-white border-2 rounded-2xl overflow-hidden">
                        <div className="relative w-full h-[10%] bg-gradient-to-r from-[#45B07B] to-[#12A57C]   rounded-t-2xl font-bold text-lg sm:text-2xl mb-4 py-2">
                            <h2 className="text-center text-white ">
                                Provide your feedback!
                            </h2>
                            <button
                                onClick={handleClose}
                                className="py-auto absolute right-2 sm:right-4 top-1 bg-white rounded-md w-8 h-[80%] flex items-center justify-center ml-auto text-red-500"
                            >
                                x
                            </button>
                        </div>
                        <form
                            onSubmit={handleSubmit}
                            className="flex flex-col flex-1 h-[90%] overflow-y-auto"
                        >
                            <div className="text-center w-full justify-center mb-8 text-black">
                                <p className="mb-4">
                                    How was your overall experience with COGRMS?
                                </p>
                                <div className="flex cursor-pointer justify-evenly">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <span
                                            key={star}
                                            onClick={() => setRating(star)}
                                            className="w-16 sm:w-24"
                                        >
                                            <span
                                                className={`sm:text-6xl text-4xl 
                      ${star <= rating ? "text-orange-500 " : "text-gray-300"}`}
                                            >
                                                ★
                                            </span>
                                            <span>
                                                <p>{labels[star - 1]}</p>
                                            </span>
                                        </span>
                                    ))}
                                </div>
                            </div>
                            <div className="text-center w-full text-black">
                                <h3 className="ml-3">Feedback/Suggestions</h3>
                                <textarea
                                    rows={5}
                                    placeholder="Write your feedback here..."
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    className="w-[90%] border rounded-xl p-3 mx-auto block my-4"
                                ></textarea>
                            </div>

                            <div className="w-full mt-auto flex justify-end pr-6 pb-6">
                                <button
                                    type="submit"
                                    className="bg-gradient-to-r from-[#45B07B] to-[#12A57C] rounded-xl text-white p-2"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {submitted && (
                <div className="fixed bottom-0 left-0 w-screen h-screen bg-black/40 flex justify-center items-center z-[99999] ">
                    <div className="flex flex-col w-[80vw] sm:w-[40vw] h-[25vh] sm:h-[15vh] bg-white border-2 rounded-2xl">
                        <div className="relative flex items-center justify-center w-full h-full bg-gradient-to-r from-[#45B07B] to-[#12A57C] rounded-2xl font-bold text-lg sm:text-2xl p-auto">
                            <h2 className="text-center text-white ">
                                Feedback submitted successfully!
                            </h2>
                            <button
                                onClick={handleClose}
                                className="py-auto absolute right-2 sm:right-4 top-1 bg-white rounded-md w-8 h-10 flex items-center justify-center ml-auto text-red-500"
                            >
                                x
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Feedback;
